<template>
  <div>
    <a-modal
      :destroyOnClose="true"
      :visible="visible"
      :title="isUpdateMode ? '修改词条国际化语言' : '创建词条国际化语言'"
      width="40%"
      centered
      okText="确认"
      cancelText="取消"
      @ok="() => onSubmit()"
      @cancel="() => hideDialog()"
    >
      <a-form-model layout="vertical" :model="form" :rules="rules" ref="form">
        <a-form-model-item label="国际化语言编号" prop="id">
          <a-input :disabled="isUpdateMode" width="100%" v-model="form.id" placeholder="请输入国际化语言编号">
          </a-input>
        </a-form-model-item>
        <a-form-model-item label="国际化语言名称" prop="name">
          <a-input width="100%" v-model="form.name" placeholder="请输入国际化语言名称"> </a-input>
        </a-form-model-item>
      </a-form-model>
    </a-modal>
  </div>
</template>

<script>
import clonedeep from 'lodash.clonedeep';

export default {
  name: 'LanguageFormModal',
  components: {},
  mounted() {},
  data() {
    return {
      rules: {
        id: [{ required: true, message: '国际化语言编号 不能为空', trigger: 'blur' }],
        name: [{ required: true, message: '国际化语言名称 不能为空', trigger: 'blur' }],
      },
      visible: false,
      isUpdateMode: false,
      resultCallBack: {
        onSubmit: Function,
      },
      form: {},
    };
  },
  methods: {
    cancel() {
      this.$router.back();
    },
    hideDialog() {
      this.visible = false;
      this.form = {};
    },
    showCreateDialog(callback) {
      this.isUpdateMode = false;
      this.form = {
        id: undefined,
      };
      this.resultCallBack.onSubmit = callback;
      this.visible = true;
    },
    showUpdateDialog(pararms, callback) {
      this.isUpdateMode = true;
      this.form = clonedeep(pararms);
      this.resultCallBack.onSubmit = callback;
      this.visible = true;
    },
    onSubmit() {
      this.$refs.form.validate((relsValid) => {
        if (relsValid) {
          this.resultCallBack.onSubmit(this.form);
          this.hideDialog();
        } else {
          this.$message.warn('基础信息存在未填写的数据');
        }
      });
    },
  },
};
</script>
